<template>
  <tr>
    <td class="info-label">
      {{ label }}
    </td>
    <td>
      {{ value }}
    </td>
  </tr>
</template>

<script>
export default {
  name: 'infos-campaign-table-row',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String|Number,
      default: ''
    }
  },
}
</script>

<style scoped>
td {
  padding: 3px 6px;
}

.info-label {
  font-weight: bold;
  width: 300px;
  background-color: #eee;
}
</style>